import React from 'react'

const Loader = () => {
  return (
    <lottie-player src="https://assets2.lottiefiles.com/private_files/lf30_fup2uejx.json"  background="transparent"  speed="1"   loop  autoplay></lottie-player>
  )
}

export default Loader